import {
  FormControl as oFormControl,
  FormControlLabel as oFormControlLabel,
  Select as oSelect,
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import styled from 'styled-components';

export const Close = styled.img`
  width: 32px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    top: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  font-weight: bold;
`;

export const FormControl = styled(oFormControl)`
  && {
    margin: 0;
  }
`;

export const FormControlLabel = styled(oFormControlLabel)`
  && {
    padding: 0;
    margin: 8px 0;
  }
  && span {
    font-size: 14px;
  }
`;

export const RadioButton = styled(Radio)`
  && span {
    color: inherit !important;
  }
`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FormItemContainer = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

export const Select = styled(oSelect)`
  && {
    font-size: 14px;
  }
`;
